import React from 'react'
import Forbidden from '../components/forbidden/Forbidden'

const ForbiddenPage = () => {
    return (
        <div className='outletConainer'>
            <Forbidden />
        </div>
    )
}

export default ForbiddenPage
